import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";

const createBusinessProfileFields: InputField[] = [
  {
    label: "Название профиля",
    name: "display_name",
    placeholder: "ElasticWork.Space",
    type: "text",
    isRequired: true,
  },
  {
    label: "Адрес",
    name: "legal_address",
    placeholder: "г. Москва, ул...",
    type: "text",
    isRequired: true,
  },
  {
    label: "ИНН",
    name: "inn",
    placeholder: "",
    type: "text",
    isRequired: false,
  },
  {
    label: "ОГРН",
    name: "ogrn",
    placeholder: "",
    type: "text",
    isRequired: false,
  },
  {
    label: "Почта для копий",
    name: "copy_email",
    placeholder: "",
    type: "text",
    isRequired: false,
    tooltip:
      "На эту почту будут отправляться копии всех счетов, отправленных арендаторам с платформы",
  },
  {
    label: "Токен для ChatPush",
    name: "chatpush_token",
    placeholder: "",
    type: "text",
    isRequired: false,
    tooltip: "Токен для отправки уведомлений арендаторам через WhatsApp и SMS",
  },
];

export function CreateBusinessProfileModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const navigate = useNavigate();
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: {
    display_name: string;
    legal_address: string;
    inn: string;
    ogrn: string;
    copy_email: string;
    chatpush_token: string;
  }) => {
    return new Promise<boolean>((resolve) => {
      api.businessProfiles
        .create({
          display_name: data.display_name,
          legal_address: data.legal_address,
          inn: data.inn,
          ogrn: data.ogrn,
          copy_email: data.copy_email,
          chatpush_token: data.chatpush_token,
        })
        .then(() => {
          disclosure.onClose();
          navigate("/dashboard/selectProfile");
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание бизнес-профиля"
      modalErrors={modalErrors}
      fields={createBusinessProfileFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
}
